import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
var CourseLearningHomePageComponent = (function () {
    function CourseLearningHomePageComponent(apiService) {
        this.apiService = apiService;
        this.onLessonChosen = new EventEmitter();
        this.onExit = new EventEmitter();
    }
    CourseLearningHomePageComponent.prototype.ngOnInit = function () {
        this.courseNumber = this.course.lessons.length;
        this.setFinishedNumber();
    };
    CourseLearningHomePageComponent.prototype.ngAfterViewInit = function () {
        var html = document.documentElement;
        var htmlFontSize;
        /*if(html.clientWidth<window.screen.height){
            htmlFontSize = html.clientWidth / 7.5;
        }else{
            htmlFontSize = window.screen.height/ 7.5;
        }*/
        if (window.screen.width < window.screen.height) {
            htmlFontSize = window.screen.width / 7.5;
        }
        else {
            htmlFontSize = window.screen.height / 7.5;
        }
        html.style.fontSize = htmlFontSize + "px";
        html.style.backgroundColor = "#fff";
        var lessons = this.course.lessons;
        var lessonsLength = lessons.length;
        var firstFinded = false;
        for (var i = 0; i < lessonsLength; i++) {
            $(".card").eq(i).find(".cardPic").css("backgroundImage", "url(" + lessons[i].picture + ")");
            if (lessons[i].status == 2) {
                $(".card").eq(i).find(".lessonStatus").css("background", "#7ccfc8");
                $(".card").eq(i).find(".lessonStatus").text("已完成");
            }
            else if (lessons[i].status < 2 && !firstFinded) {
                firstFinded = !firstFinded;
                this.firstUnfinished = i;
            }
        }
        var cardWidth = htmlFontSize * 5.2;
        var spaceWidth = htmlFontSize * 0.36;
        var swiper = new Swiper('#cards_wrap', {
            width: cardWidth,
            spaceBetween: spaceWidth,
            onTransitionEnd: function (swiper) {
                $("#head_wrap_picture").css("backgroundImage", "url(" + lessons[swiper.activeIndex].picture + ")");
            }
        });
        $("#head_wrap_picture").css("backgroundImage", "url(" + lessons[swiper.activeIndex].picture + ")");
        swiper.slideTo(this.firstUnfinished, 1000, true);
    };
    CourseLearningHomePageComponent.prototype.setFinishedNumber = function () {
        this.finishedNumber = 0;
        for (var i = 0; i < this.course.lessons.length; i++) {
            if (this.course.lessons[i].status == 2) {
                this.finishedNumber++;
            }
        }
        if (this.finishedNumber > 0) {
            var obj = document.getElementById('axisWrap' + this.finishedNumber);
            if (obj) {
                $(window).scrollTop(obj.offsetHeight);
            }
        }
    };
    CourseLearningHomePageComponent.prototype.getLesson = function (i) {
        if (i <= this.finishedNumber) {
            this.onLessonChosen.emit(i);
        }
    };
    CourseLearningHomePageComponent.prototype.close = function () {
        if (this.finishedNumber < this.courseNumber) {
            $("#shade").fadeIn(300);
            $("#tip1").fadeIn(300);
            this.disableRolling();
        }
        else {
            this.exit();
        }
    };
    CourseLearningHomePageComponent.prototype.continue = function () {
        $("#tip1").fadeOut(300);
        $("#shade").fadeOut(300);
    };
    CourseLearningHomePageComponent.prototype.exit = function () {
        this.onExit.emit(true);
    };
    CourseLearningHomePageComponent.prototype.disableRolling = function () {
        document.getElementById('shade').ontouchstart = function (e) { e.preventDefault(); };
    };
    return CourseLearningHomePageComponent;
}());
export { CourseLearningHomePageComponent };



// WEBPACK FOOTER //
// ./src/app/course-learning-home-page/course-learning-home-page.component.ts.pre-build-optimizer.js